import styled from "styled-components";

export const AddDiv = styled.div``;

export const FormLead = styled.div`
  h1 {
    text-align: center;
    margin: 2rem 0;
  }

  .buttons {
    margin: 1rem 0;
    display: flex;
    gap: 1rem;
  }

  .content {
    margin: 0 auto 1.5rem auto;
    max-width: 1100px;
    padding: 1rem 1.5rem;
    background-color: #fff;
    border-radius: 10px;

    .form {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      /* justify-content: center; */
    }
  }
`;
